import config from "@Config/index";
import currencyData from "constants/currencyConstants";
import axios from "axios";

export const getCurrencySymbol = (currency: any) =>
  currencyData.find(({ short_name, standard_name }) =>
    [short_name?.toLocaleLowerCase(), standard_name?.toLocaleLowerCase()].includes(
      currency?.toLocaleLowerCase(),
    ),
  )?.symbol || "";

export const getPricingCurrency = (currency: any) => {
  const finalCurrencyObject = currencyData.find(
    (currencyObject) =>
      currencyObject?.short_name?.toLocaleLowerCase() === currency?.toLocaleLowerCase() ||
      currencyObject?.standard_name?.toLocaleLowerCase() === currency?.toLocaleLowerCase(),
  );

  if (finalCurrencyObject) {
    return finalCurrencyObject.symbol;
  }
  return "£";
};

export const getPriceTrends = async (id: any) => {
  try {
    const { data } = await axios.get(`${config.API_URL}/api/v0/inventories/${id}/price_trends`, {
      withCredentials: true,
    });
    return data;
  } catch (error: any) {
    return { error };
  }
};
